// extracted by mini-css-extract-plugin
module.exports = {"active-category":"sideMenu_active-category__3ghV8","category":"sideMenu_category__3fBDt"};